import { LinkStyled } from '@gr-monorepo/common/ui';
import useUserData from 'hooks/useUserData';
import React, { useEffect, useMemo } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import styled from 'styled-components';
import { replaceTemplateVariables } from 'utils/markdownCopyText';

interface MarkdownPreviewProps {
  content: string;
}

const StyledParagraph = styled.p`
  margin: 0;
  margin-top: 14px;
  color: #333;

  &:first-child {
    margin-top: 0;
  }
`;

const Bold = styled.span`
  font-weight: bold;
`;

const UnorderedList = styled.ul`
  margin: 14px 0 0 18px;
  padding: 0;
  list-style-type: disc;

  &:first-child {
    margin-top: 0;
  }
`;

const OrderedList = styled.ol`
  margin: 14px 0 0 18px;
  padding: 0;
  list-style-type: decimal;

  &:first-child {
    margin-top: 0;
  }
`;

const ListItem = styled.li`
  margin: 6px 0;
  color: #333;

  &::marker {
    color: black;
  }
`;

const components: Components = {
  p: ({ children }: { children: React.ReactNode }) => <StyledParagraph>{children}</StyledParagraph>,
  a: ({ href, children }: { href?: string; children: React.ReactNode }) => (
    <LinkStyled style={{ color: '#7F39FB' }} href={href} target="_blank">
      {children}
    </LinkStyled>
  ),
  strong: ({ children }: { children: React.ReactNode }) => <Bold>{children}</Bold>,
  ul: ({ children }: { children: React.ReactNode }) => <UnorderedList>{children}</UnorderedList>,
  ol: ({ children }: { children: React.ReactNode }) => <OrderedList>{children}</OrderedList>,
  li: ({ children }: { children: React.ReactNode }) => <ListItem>{children}</ListItem>,
};

interface MarkdownPreviewProps {
  content: string;
  replaceUtmTerm?: boolean;
  componentsStyle?: Components;
}

const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({
  content,
  replaceUtmTerm = false,
  componentsStyle = components,
}: MarkdownPreviewProps) => {
  const userData = useUserData();
  const cabmunId = userData?.id;
  const processedContent = useMemo(
    () => (replaceUtmTerm && cabmunId ? replaceTemplateVariables(content, cabmunId) : content),
    [content, replaceUtmTerm, cabmunId],
  );

  return <ReactMarkdown components={componentsStyle}>{processedContent}</ReactMarkdown>;
};

export default MarkdownPreview;
